module.exports = __webpack_public_path__ + "media/images/demo/boxed-layout-a6354bf15e7385af8503a7f231d9f77b.jpg";